import { create } from 'zustand';

/**
 * Small singleton store to open the "Scarica l'app" instructions
 * dialog from anywhere (header, footer, banner, landing CTA…).
 *
 * Also holds the deferred `beforeinstallprompt` event so any button
 * in the app can trigger the native Chrome/Edge install prompt.
 */
export const useInstallStore = create((set) => ({
  open: false,
  deferredPrompt: null,
  setDeferredPrompt: (evt) => set({ deferredPrompt: evt }),
  clearDeferredPrompt: () => set({ deferredPrompt: null }),
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}));

export function isStandaloneMode() {
  if (typeof window === 'undefined') return false;
  return (
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

export function detectPlatform() {
  if (typeof window === 'undefined') return 'other';
  const ua = window.navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/i.test(ua);
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS|Chrome/.test(ua);
  const isChromeAndroid = isAndroid && /Chrome/.test(ua);
  const isSamsung = /SamsungBrowser/.test(ua);

  if (isIOS && isSafari) return 'ios-safari';
  if (isIOS) return 'ios-other'; // Chrome/Firefox iOS — must switch to Safari
  if (isChromeAndroid) return 'android-chrome';
  if (isSamsung) return 'android-samsung';
  if (isAndroid) return 'android-other';
  return 'desktop';
}
